import {Component, Input, Output, ElementRef, OnInit, OnChanges, AfterViewInit, SimpleChanges, EventEmitter} from '@angular/core';

import {WindowService} from "../services/window.service";
import {Logger} from "../utils/logger";
import {EmailService} from "../services/email.service";
import {CONFIG} from "../config";

@Component({
    selector: 'email_box',    
    providers: [EmailService],   
    templateUrl: "./email_box.component.html"
})
export class EmailBox implements OnInit, OnChanges{

    @Input('show')
    // public needShow = false;
    public isShown = false;

    @Output('onHide')
    public displayEvent:EventEmitter<boolean>;

    @Input()
    public configuration;

    @Input()
    public link;

    @Input()
    public storeId;

    public basePath = "";

    public model = {
        email: "",
        name: "",
        link: ""
    };
    public domain;

    public isSuccessBoxShown = false;

    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger, public emailService: EmailService){
        this.displayEvent = new EventEmitter<boolean>();
        this.domain = "http://" + window.location.hostname;
        this.basePath = CONFIG.baseUrl + "#";
    }

    ngOnInit():any {

    }


    ngOnChanges(changes: any):any {
        if(typeof changes.link !== 'undefined' && changes.link.currentValue){
            this.model.link = changes.link.curentValue;
        }
        if(this.el.nativeElement && typeof changes.isShown !== 'undefined' && changes.isShown.previousValue === false && changes.isShown.currentValue === true){
            setTimeout(() =>{
                this.el.nativeElement.querySelector(".name-control").focus();
            },500)
        }
        // if (typeof changes.needShow !== 'undefined') {
        //     if (changes.needShow.currentValue && changes.needShow.currentValue !== changes.needShow.previousValue) {
        //         this.show();
        //     } else {
        //         this.hide();
        //     }
        // }
    }

    send(event: Event){
        this.emailService.send(this.model.name, this.model.email, this.link, this.storeId).subscribe((resp) => {
            if(resp.success){
                this.hide();
                this.isSuccessBoxShown = true;
            }else {
                window.alert(resp.message);
            }
        })
    }


    hide() {
        this.displayEvent.emit(true);
        this.isShown = false;
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeOut").hide(s).then(()=> {
        //     this.model.name = "";
        //     this.model.email = "";
        //     this.displayEvent.emit(true);
        //     this.isShown = false;
        // });
    }

    show() {
        this.isShown = true;
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeIn").show(s).then(()=> {
        //
        // });
    }

    hideSuccessBox(){
        this.isSuccessBoxShown = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/popups/email_box.component.ts